<template>
  <div class="eula-dialog">
      <meta content="text/html; charset=UTF-8" http-equiv="content-type">


    <div class="c7 doc-content"><p class="c10"><span class="c3">INTELLECTUAL PROPERTY AND LICENSING AGREEMENT</span>
    </p>
    <p class="c0"><span class="c4 c1">This Intellectual Property and Licensing Agreement (this &ldquo;Agreement&rdquo;) is entered into by and between AI Vector, LLC, a Utah limited liability company, with its principal place of business at 933 E 1910 S, Suite 101, Provo, UT 84606 (&ldquo;Provider&rdquo;), and the end user of the Provider&rsquo;s Services (&ldquo;Customer&rdquo;).</span>
    </p>
    <p class="c0"><span class="c3">RECITALS</span></p>
    <p class="c0"><span class="c4 c1">WHEREAS, Provider is the developer and owner of certain hardware and software-based cybersecurity solutions, including a proprietary monitoring device (the &ldquo;Device&rdquo;), related software services, and cyber risk mitigation tools (collectively, the &ldquo;Services&rdquo;);</span>
    </p>
    <p class="c0"><span class="c4 c1">WHEREAS, Customer desires to obtain and Provider agrees to grant a limited license to use the Services subject to the terms and conditions set forth herein.</span>
    </p>
    <p class="c0"><span class="c4 c1">NOW, THEREFORE, in consideration of the mutual covenants contained herein, and for other good and valuable consideration, the parties agree as follows:</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">1. DEFINITIONS</span></p>
    <p class="c0"><span class="c1">1.1 </span><span class="c3">Device</span><span class="c4 c1">: The proprietary hardware provided by Provider that monitors Customer&rsquo;s home or network-connected environment.</span>
    </p>
    <p class="c0"><span class="c1">1.2 </span><span class="c3">Monitoring Services</span><span class="c4 c1">: The real-time analysis of network activity and device behavior within the Customer&rsquo;s premises, performed through the Device and related software.</span>
    </p>
    <p class="c0"><span class="c1">1.3 </span><span class="c3">Services</span><span class="c4 c1">: The combined offering of the Device, Monitoring Services, software components, user interface, reporting tools, and cybersecurity insurance coverage.</span>
    </p>
    <p class="c0"><span class="c1">1.4 </span><span class="c3">Documentation</span><span class="c4 c1">: User guides, technical manuals, instructions, and related materials provided by Provider in any form.</span>
    </p>
    <p class="c0"><span class="c1">1.5 </span><span class="c3">Intellectual Property Rights</span><span class="c4 c1">: All rights, title, and interest, including but not limited to patents, copyrights, trade secrets, trademarks, moral rights, and any other proprietary rights recognized by law.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">2. LICENSE GRANT</span></p>
    <p class="c0"><span class="c1">2.1 </span><span class="c3">Limited License</span><span class="c4 c1">: Subject to the terms of this Agreement, Provider hereby grants to Customer a non-exclusive, non-transferable, non-sublicensable, limited license to use the Services solely for personal, non-commercial purposes within the Customer&rsquo;s household.</span>
    </p>
    <p class="c0"><span class="c1">2.2 </span><span class="c3">Restrictions</span><span class="c4 c1">: Customer shall not (i) copy, modify, or create derivative works of the Services; (ii) reverse engineer, decompile, disassemble, or otherwise attempt to derive source code; (iii) distribute, sell, lease, sublicense, or transfer the Services; or (iv) use the Services to operate a service bureau or provide time-sharing services.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">3. ACCEPTANCE OF TERMS</span></p>
    <p class="c0"><span class="c4 c1">By installing, activating, or using the Services, Customer affirms that they have read, understood, and accepted the terms of this Agreement. If Customer does not agree, they must cease using the Services immediately.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">4. MONITORING SERVICES</span></p>
    <p class="c0"><span class="c1">4.1 </span><span class="c3">Scope</span><span class="c4 c1">: Provider shall monitor Customer&rsquo;s network and connected devices to identify potential cybersecurity threats, performance issues, and unauthorized activity.</span>
    </p>
    <p class="c0"><span class="c1">4.2 </span><span class="c3">Data Use</span><span class="c4 c1">: All data collected will be used for purposes of service improvement, threat analysis, and insurance support, in accordance with Provider&rsquo;s Privacy Policy.</span>
    </p>
    <p class="c0"><span class="c1">4.3 </span><span class="c3">Disclaimer</span><span class="c4 c1">: Provider does not guarantee uninterrupted monitoring or error-free performance.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">5. CUSTOMER OBLIGATIONS</span></p>
    <p class="c0"><span class="c1">5.1 </span><span class="c3">Lawful Use</span><span class="c4 c1">: Customer agrees to use the Services in compliance with all applicable laws and regulations.</span>
    </p>
    <p class="c0"><span class="c1">5.2 </span><span class="c3">Security Practices</span><span class="c4 c1">: Customer shall implement best practices, including changing passwords and applying software updates, as recommended by Provider.</span>
    </p>
    <p class="c0"><span class="c1">5.3 </span><span class="c3">Incident Notification</span><span class="c4 c1">: Customer agrees to promptly report malfunctions or suspected security incidents to Provider.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">6. DATA PRIVACY AND SECURITY</span></p>
    <p class="c0"><span class="c1">6.1 </span><span class="c3">Privacy Policy</span><span class="c4 c1">: Provider&rsquo;s Privacy Policy is incorporated into this Agreement by reference. Customer consents to data collection and processing under said policy.</span>
    </p>
    <p class="c0"><span class="c1">6.2 </span><span class="c3">Security Standards</span><span class="c4 c1">: Provider employs commercially reasonable security measures, but disclaims any guarantee of absolute data security.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">7. INTELLECTUAL PROPERTY RIGHTS</span></p>
    <p class="c0"><span class="c1">7.1 </span><span class="c3">Ownership</span><span class="c1 c4">: All Intellectual Property Rights in and to the Services, including all updates, enhancements, and derivative works, are and shall remain the exclusive property of Provider.</span>
    </p>
    <p class="c0"><span class="c1">7.2 </span><span class="c3">No Implied Rights</span><span class="c4 c1">: Except as expressly provided, no license or other rights are granted to Customer under any Intellectual Property Rights.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">8. LIMITATION OF LIABILITY AND DISCLAIMER</span></p>
    <p class="c0"><span class="c1">8.1 </span><span class="c3">Disclaimer of Warranties</span><span class="c4 c1">: THE SERVICES ARE PROVIDED &ldquo;AS IS&rdquo; AND &ldquo;AS AVAILABLE.&rdquo; PROVIDER DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, AND ACCURACY.</span>
    </p>
    <p class="c0"><span class="c1">8.2 </span><span class="c3">Limitation of Liability</span><span class="c4 c1">: IN NO EVENT SHALL PROVIDER BE LIABLE FOR INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES. TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT PAID BY CUSTOMER FOR THE SERVICES IN THE PRECEDING TWELVE (12) MONTHS.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c3 c5">9. INDEMNIFICATION</span></p>
    <p class="c0"><span class="c4 c1">Customer agrees to indemnify and hold harmless Provider and its officers, employees, agents, and affiliates from any claims, damages, or liabilities arising out of (i) Customer&rsquo;s use or misuse of the Services; (ii) any breach of this Agreement; or (iii) infringement of any third-party rights.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">10. TERM AND TERMINATION</span></p>
    <p class="c0"><span class="c1">10.1 </span><span class="c3">Term</span><span class="c4 c1">: This Agreement remains effective from the date of activation until terminated in accordance with this Section.</span>
    </p>
    <p class="c0"><span class="c1">10.2 </span><span class="c3">Termination by Customer</span><span class="c4 c1">: Customer may terminate this Agreement by ceasing use of the Services. Ongoing obligations under applicable insurance policies may survive termination.</span>
    </p>
    <p class="c0"><span class="c1">10.3 </span><span class="c3">Termination by Provider</span><span class="c4 c1">: Provider may terminate or suspend Services immediately upon notice for breach, unlawful use, or if required by law.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">11. DISPUTE RESOLUTION</span></p>
    <p class="c0"><span class="c4 c1">Any dispute arising under or in connection with this Agreement shall be resolved exclusively through binding arbitration administered by the American Arbitration Association under its Commercial Arbitration Rules. The arbitration shall take place in Utah County, Utah. Judgment on the arbitration award may be entered in any court having jurisdiction.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">12. GOVERNING LAW</span></p>
    <p class="c0"><span class="c4 c1">This Agreement shall be governed by and construed under the laws of the State of Utah, without regard to its conflict of laws principles.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">13. ASSIGNMENT</span></p>
    <p class="c0"><span class="c4 c1">Customer may not assign this Agreement without Provider&rsquo;s prior written consent. Any unauthorized assignment shall be null and void.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">14. FORCE MAJEURE</span></p>
    <p class="c0"><span class="c4 c1">Provider shall not be liable for delays or failures caused by events beyond its reasonable control, including acts of God, natural disasters, war, terrorism, labor disruptions, or governmental actions.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">15. ENTIRE AGREEMENT</span></p>
    <p class="c0"><span class="c4 c1">This Agreement, including all policies and documents incorporated by reference (e.g., Privacy Policy, insurance documentation), constitutes the entire agreement between the parties and supersedes all prior agreements or understandings, whether written or oral.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">16. AMENDMENTS</span></p>
    <p class="c0"><span class="c4 c1">Provider reserves the right to amend this Agreement. Customer will be notified of material changes, and continued use of the Services constitutes acceptance of the modified Agreement.</span>
    </p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c5 c3">17. CONTACT INFORMATION</span></p>
    <p class="c0"><span class="c4 c1">For inquiries regarding this Agreement or the Services, contact:</span></p>
    <p class="c0"><span class="c3">AI Vector, LLC</span><span
        class="c1"><br>933 E 1910 S, Suite 101<br>Provo, UT 84606<br>Email: </span><span
        class="c6">info@aivector.com</span><span class="c1"><br>Phone: </span><span class="c6">(800) 316-2802</span></p>
    <hr>
    <p class="c2"><span class="c4 c1"></span></p>
    <p class="c0"><span class="c3">IN WITNESS WHEREOF</span><span class="c4 c1">, by using the Services, Customer acknowledges and agrees to the terms and conditions of this Agreement.</span>
    </p>
    <p class="c9"><span class="c4 c8"></span></p></div>

  </div>
</template>

<script>
export default {
  name: 'TermsAndConditions',
  props: {},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

ol {
  margin: 0;
  padding: 0
}

table td, table th {
  padding: 0
}

.c9 {
  padding-top: 0pt;
  padding-bottom: 8pt;
  line-height: 1.1583333333333334;
  orphans: 2;
  widows: 2;
  text-align: left;
  height: 12pt
}

.c2 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  orphans: 2;
  widows: 2;
  text-align: left;
  height: 12pt
}

.c10 {
  padding-top: 0pt;
  padding-bottom: 14pt;
  line-height: 1.0;
  orphans: 2;
  widows: 2;
  text-align: left
}

.c0 {
  padding-top: 14pt;
  padding-bottom: 14pt;
  line-height: 1.0;
  orphans: 2;
  widows: 2;
  text-align: left
}

.c4 {
  color: #000000;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 12pt;
  font-style: normal
}

.c5 {
  color: #000000;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 13.5pt;
  font-style: normal
}

.c6 {
  background-color: #ffffff;
  font-family: "Arial";
  color: #333333;
  font-weight: 400
}

.c7 {
  background-color: #ffffff;
  /*max-width: 468pt;*/
  padding: 5px;
}

.c3 {
  font-weight: 700;
  font-family: "Times New Roman"
}

.c8 {
  font-weight: 400;
  font-family: "Aptos"
}

.c1 {
  font-weight: 400;
  font-family: "Times New Roman"
}

.title {
  padding-top: 0pt;
  color: #000000;
  font-size: 28pt;
  padding-bottom: 4pt;
  font-family: "Play";
  line-height: 1.0;
  orphans: 2;
  widows: 2;
  text-align: left
}

.subtitle {
  padding-top: 0pt;
  color: #595959;
  font-size: 14pt;
  padding-bottom: 8pt;
  font-family: "Aptos";
  line-height: 1.1583333333333334;
  orphans: 2;
  widows: 2;
  text-align: left
}

li {
  color: #000000;
  font-size: 12pt;
  font-family: "Aptos"
}

p {
  margin: 0;
  color: #000000;
  font-size: 12pt;
  font-family: "Aptos"
}

h1 {
  padding-top: 18pt;
  color: #0f4761;
  font-size: 20pt;
  padding-bottom: 4pt;
  font-family: "Play";
  line-height: 1.1583333333333334;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

h2 {
  padding-top: 8pt;
  color: #0f4761;
  font-size: 16pt;
  padding-bottom: 4pt;
  font-family: "Play";
  line-height: 1.1583333333333334;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

h3 {
  padding-top: 8pt;
  color: #0f4761;
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: "Aptos";
  line-height: 1.1583333333333334;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

h4 {
  padding-top: 4pt;
  color: #0f4761;
  font-size: 12pt;
  padding-bottom: 2pt;
  font-family: "Aptos";
  line-height: 1.1583333333333334;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left
}

h5 {
  padding-top: 4pt;
  color: #0f4761;
  font-size: 12pt;
  padding-bottom: 2pt;
  font-family: "Aptos";
  line-height: 1.1583333333333334;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

div .eula-dialog {
  word-break: normal !important;
  overflow-wrap: normal !important;
  hyphens: none !important;
}



h6 {
  padding-top: 2pt;
  color: #595959;
  font-size: 12pt;
  padding-bottom: 0pt;
  font-family: "Aptos";
  line-height: 1.1583333333333334;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left
}
</style>
